// src/store/slices/themeSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ThemeSettings } from '../../types/theme'; // or define inline

const API_URL = import.meta.env.VITE_API_BASE_URL || 'https://thalvora-exports.onrender.com';

export const fetchTheme = createAsyncThunk('theme/fetch', async () => {
  const res = await axios.get(`${API_URL}/settings/theme`);
  return res.data;
});

export const updateTheme = createAsyncThunk('theme/update', async (data: ThemeSettings, { getState }) => {
  const state: any = getState();
  const token = state.auth.token;
  const res = await axios.put(`${API_URL}/settings/theme`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
});

const initialState: ThemeSettings = {
  primaryColor: '#40a040',
  secondaryColor: '#e6b422',
  successColor: '#10b981',
  warningColor: '#f59e0b',
  errorColor: '#ef4444',
  infoColor: '#3b82f6',
  fontFamily: 'Poppins, sans-serif',
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTheme.fulfilled, (_, action) => action.payload)
      .addCase(updateTheme.fulfilled, (_, action) => action.payload);
  },
});

export default themeSlice.reducer;